export enum SenderAvailabilityTypeList {
  APPOINTMENT = 'appointment',
  REMIND = 'remind',
  TOUR = 'tour',
  POS = 'pos',
  DOCUMENTS = 'documents',
  COMMON = 'common',
}
